<ds-checkbox size="medium" [checked]="selection.isSelected" [disabled]="isDisabled" (checkedChange)="togglePickSelection($event)" />
